import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

import * as configLib from 'libs/configLib';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'config/INITIAL_STORE';
const GET_SVCCONFIG = 'config/GET_SVCCONFIG';
const GET_CONN_LDAP = 'config/GET_CONN_LDAP';
const UPDATE_SVCCONFIG = 'config/UPDATE_SVCCONFIG';
const CHECK_SMTP = 'config/CHECK_SMTP';
const SVCCONF_INITIAL_SMTP = 'admin/SVCCONF_INITIAL_SMTP';
const TARGET_SYNC = 'config/TARGET_SYNC';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const getServiceConfig = createAction(GET_SVCCONFIG, configLib.getServiceConfig);
export const getConnLDAP = createAction(GET_CONN_LDAP, configLib.getConnLDAP);
export const updateServiceConfig = createAction(UPDATE_SVCCONFIG, configLib.updateServiceConfig);
export const checkSmtp = createAction(CHECK_SMTP, configLib.checkSmtp);
export const ServiceConfigInitSmtp = createAction(SVCCONF_INITIAL_SMTP, configLib.ServiceConfigInitSmtp);
export const targetSync = createAction(TARGET_SYNC, configLib.targetSync);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: []
  },
  indexByNo: {},
  needReload: false,
  smtpConfig: {},
  eduConfig: {},
  declareConfig: {}
});

// reducer
export default handleActions(
  {
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    ...pender({
      type: GET_SVCCONFIG,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { category } = action.payload.config.params;

        return state.set(category + 'Config', fromJS(normal.systemConfigData(list)));
      },
      onFailure: (state, action) => {
        console.log('GET_SVCCONFIG 실패');

        return state;
      }
    }),
    ...pender({
      type: GET_CONN_LDAP,
      onSuccess: (state, action) => {
        console.log('GET_CONN_LDAP 성공');
      },
      onFailure: (state, action) => {
        console.log('GET_CONN_LDAP 실패');

        return state;
      }
    }),
    ...pender({
      type: UPDATE_SVCCONFIG,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { category, parameter, value } = list[0];

        return state.setIn([category + 'Config', 'parameter', parameter, 'beforeValue'], value);
      },
      onFailure: (state, action) => {
        console.log('UPDATE_SVCCONFIG 실패');

        return state;
      }
    }),
    ...pender({
      type: CHECK_SMTP,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        return state.setIn(['smtpConfig', 'parameter', 'mailSmtpTested'], fromJS(list));
      },
      onFailure: (state, action) => {
        console.log('CHECK_SMTP 실패');

        return state;
      }
    }),
    ...pender({
      type: SVCCONF_INITIAL_SMTP,
      onSuccess: (state, action) => {
        return initialState;
      },
      onFailure: (state, action) => {
        return state;
      }
    }),
    ...pender({
      type: TARGET_SYNC,
      onSuccess: (state, action) => {
        console.log('TARGET_SYNC 성공');
      },
      onFailure: (state, action) => {
        console.log('TARGET_SYNC 실패');

        return state;
      }
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/config.js